<template>
  <div>
    <v-row>
      <v-col>
        <h2 v-if="$route.params.id != undefined">{{ $t('analyst_coverage.edit_analyst_coverage') }}</h2>
        <h2 v-else>{{ $t('analyst_coverage.new_analyst_coverage') }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field :label="$t('analyst_coverage.company')" v-model="analyst_coverage_data.company"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field :label="$t('analyst_coverage.analyst')" v-model="analyst_coverage_data.analyst"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          :label="$t('analyst_coverage.email')"
          type="email"
          :rules="emailRules"
          v-model="analyst_coverage_data.email"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mt-8">
      <v-col>
        <v-btn
          v-if="$route.params.id != undefined"
          color="success"
          depressed
          @click="updateAnalystCoverage"
          :loading="loading"
        >
          {{ $t('general.save') }}
        </v-btn>
        <v-btn v-else color="success" depressed @click="AddAnalystCoverage" :loading="loading">
          {{ $t('general.add') }}
        </v-btn>
      </v-col>
    </v-row>
    <SnackBar :text="snack_bar_text" :snackbar="snack_bar_open" v-on:close="updateSnackBar" />
  </div>
</template>

<script>
import { getData, postData } from '@/api'
import SnackBar from '@/components/SnackBar'
import { globalFunc } from '@/global'

export default {
  name: 'AnalystCoverageDetail',
  mixins: [globalFunc],
  components: {
    SnackBar,
  },
  data: () => ({
    emailRules: [
      v =>
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v,
        ) || 'E-mail must be valid',
    ],
    analyst_coverage_data: {
      company: '',
      analyst: '',
      email: '',
    },
    snack_bar_text: '',
    snack_bar_open: false,
    loading: false,
  }),
  methods: {
    async initializeAnalystCoverage() {
      if (!this.loading) {
        this.loading = true
        let error = true

        try {
          let params = new URLSearchParams()

          params.set(
            'get_single_data_by_data_type_and_id',
            JSON.stringify({
              id: this.$route.params.id,
              data_type: 'analyst_coverage_data',
            }),
          )

          let result = await getData(params)
          if (globalFunc.DataValid(result)) {
            Object.assign(this.analyst_coverage_data, result)
            error = false
          }
        } catch (error) {
          globalFunc.log(error)
        }

        if (error) {
          this.snack_bar_text = this.$t('instruction.data_not_found')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'AnalystCoverage' })
          }, 2000)
        } else {
          this.loading = false
        }
      }
    },
    async AddAnalystCoverage() {
      if (!this.loading) {
        this.loading = true
        if (!globalFunc.DataValid(this.analyst_coverage_data.company)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('analyst_coverage.company')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.analyst_coverage_data.analyst)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('analyst_coverage.analyst')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.analyst_coverage_data.email)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('analyst_coverage.email')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        try {
          let params = new URLSearchParams()

          params.set('add_analyst_coverage', JSON.stringify(this.analyst_coverage_data))

          let result = await postData(params)
          globalFunc.log(result)

          this.snack_bar_text = this.$t('instruction.create_success')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'AnalystCoverage' })
          }, 2000)
        } catch (error) {
          this.snack_bar_text = this.$t('instruction.create_fail')
          this.snack_bar_open = true
          globalFunc.log(error)
          this.loading = false
        }
      }
    },
    async updateAnalystCoverage() {
      if (!this.loading) {
        this.loading = true
        if (!globalFunc.DataValid(this.analyst_coverage_data.company)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('analyst_coverage.company')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.analyst_coverage_data.analyst)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('analyst_coverage.analyst')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.analyst_coverage_data.email)) {
          this.snack_bar_text = this.$t('error.force_input') + ' ' + this.$t('analyst_coverage.email')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        try {
          let params = new URLSearchParams()

          params.set('update_analyst_coverage', JSON.stringify(this.analyst_coverage_data))

          let result = await postData(params)
          globalFunc.log(result)

          this.snack_bar_text = this.$t('instruction.update_success')
          this.snack_bar_open = true

          setTimeout(() => {
            location.reload()
          }, 2000)
        } catch (error) {
          this.snack_bar_text = this.$t('instruction.update_fail')
          this.snack_bar_open = true
          globalFunc.log(error)
          this.loading = false
        }
      }
    },
    updateSnackBar(status) {
      this.snack_bar_open = status
    },
  },
  created() {
    if (this.$route.params.id != undefined) {
      this.initializeAnalystCoverage()
    }
  },
}
</script>
